import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EsignPartnerConsltantsDetails } from '../Model/EsignPartnerConsltantsDetails';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { VesignDataService } from '../service/vesign-data.service';
import { environment } from 'src/environments/environment';
import { IAdvanceSearch } from '../Model/IAdvanceSearch';
import { PartnerConsltantViewModel } from '../Model/PartnerConsltantsViewModel';
import { DatePipe ,Location} from '@angular/common';

import * as XLSX from 'xlsx';
@Component({
  selector: 'app-partner-consltants-dashboard',
  templateUrl: './partner-consltants-dashboard.component.html',
  styleUrls: ['./partner-consltants-dashboard.component.css']
})
export class PartnerConsltantsDashboardComponent implements OnInit {
  displayedColumns: string[];
  columnsToDisplay: string[];
  candidateList = new MatTableDataSource<EsignPartnerConsltantsDetails>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  TableColumnPopupclass: string = "";
  outof: number = 0;
  totalcount: number = 0;
  StatusType: string = "";
  searchstr: string = "";
  content: string = '';
  DateRangeError: boolean = false;
  cols: any[];
  columns: any[];
  start: number = 0;
  limit: number = 10;
  end: number = this.limit + this.start;
  IsTableColumnPopupOpen: boolean = false;
  totalActiveConsCount: number;
  totalInactiveCount: number;
  OpsExecutiveList = [];
  ClientList = [];
  EndClientList = [];
  DateRangeErrorMessage: string = '';
  SelectedEsdDate = [];
  pipe = new DatePipe('en-US');
  supportingDocStyle: string = "none";
  IssupportingDocsPopupOpen: boolean = false;
  UploadedSupportingDocs = [];
  Status:any;
  candidateStatus:number=1;
  advanceSearchPopupCSS="has-icon d-block has-dropdown has-advance-filter";
  AdvanceSearch:IAdvanceSearch =
    {
      Skip: 0,
      Take: 50,
      Status: 1,
      EsdFromDate: null,
      EsdToDate: null,
      CandidateName: null,
      ClientNames: [],
      EndClientName: [],
      OPSExecutives: [],
      VendorCode: null,
      DynamicColumnsforExportToExcel: null
    }
    Search = {
      vendorCode: "",
      taskId: null,
      gcId: null,
      search: null
    }
    SearchBy={
      SearchBySpecificColumns: '',
      Vendor_code:'',
      taskId: null,
    }
  constructor(private dataService: VesignDataService<any>,private location: Location, private elRef: ElementRef, private renderer: Renderer2, private toastr: ToastrService,
    private route: Router, private spinner: NgxSpinnerService, private http: HttpClient) { }

  ngOnInit(): void {
    this.spinner.show();
    this.dataService.setVendorName(sessionStorage.getItem('UserName')!=null ? sessionStorage.getItem('UserName').toString() : "");
    this.location.replaceState('/consltantlist');
    this.GetMasterDataForAdvanceSearch();
    this.GridSetUp();
    this.candidateList.sort = this.sort;
    this.AdvanceSearch.VendorCode = sessionStorage.getItem("VendorCode");
    this.GetPartnerConsltantsDetails(this.AdvanceSearch);
    //this.candidateStatus=0;
     this.Search.vendorCode = sessionStorage.getItem("VendorCode");
     this.getTakeActionPendingDocsCount(this.Search);
     this.SearchBy.Vendor_code=this.Search.vendorCode;
     this.GetViewCompletedDocsCount(this.SearchBy);
     this.spinner.hide();
  }
  GetMasterDataForAdvanceSearch() {
    //this.spinner.show();
    this.dataService.Get(environment.eSignCommonApiUrl + "api/AdvaneFilter/GetAdvanceFilterMaster?EntityName=Asc", null)
      .subscribe(
        MasterData => {
          this.ClientList = []
          this.EndClientList = []
          this.OpsExecutiveList = []
          MasterData?.ClientList.forEach(data => {
            var row = { id: "", itemName: "" };
            row.id = data.MasterID;
            row.itemName = data.MasterName;
            this.ClientList.push(row);
          });
          MasterData?.EndClientList.forEach(data => {
            var row = { id: "", itemName: "" };
            row.id = data.MasterID;
            row.itemName = data.MasterName;
            this.EndClientList.push(row);
          });
          MasterData?.OpsExecutiveList.forEach(data => {
            var row = { id: "", itemName: "" };
            row.id = data.MasterID;
            row.itemName = data.MasterName;
            this.OpsExecutiveList.push(row);
          });
          // this.spinner.hide();
        })
  }
  updateIndex() {
    this.start = this.end;
    this.end = this.limit + this.start;
  }
  onChange(event, index, item) {
    item.checked = !item.checked;
    if (item.checked == true) {
      if (this.cols.indexOf(index) == -1) {
        this.columnsToDisplay.splice(this.cols.indexOf(item), 0, item.field);
      } else {
        this.columnsToDisplay.splice(this.columnsToDisplay.indexOf(item.field), 1)
      }
    } else {
      this.columnsToDisplay.splice(this.columnsToDisplay.indexOf(item.field), 1)
    }
  }
  OpenSlider(index) {
    this.renderer.addClass(this.elRef.nativeElement.querySelector('.row_' + index), 'active');
  }
  auxclick(index) {
    this.renderer.removeClass(this.elRef.nativeElement.querySelector('.row_' + index + '.active'), 'active');
  }
  ViewSentDocs(taskId: any, gciId: any,candidateName:any) {
   //debugger
   // this.dataService.setTabCss('viewsenddocs');
    //environment.TaskID = taskId;
    //environment.GciID = gciId;
    
    this.route.navigate(["/viewcompleteddocs"], { queryParams: { taskId: taskId,candidateName:candidateName } });
  }
  OpenSupportDocPopup(TaskId?: string) {
    this.IssupportingDocsPopupOpen = !this.IssupportingDocsPopupOpen;
    if (this.IssupportingDocsPopupOpen) {
      this.supportingDocStyle = "block"
      this.SupportDocList(TaskId)
    }
    else { this.supportingDocStyle = "none" }
  }
  SupportDocList(taskId: string) {
    this.dataService.Get(environment.eSignApiUrl + "/api/VendorEsign/GetEsignConsltantDocs?task_id=" + taskId, null)
      .subscribe(res => {
        this.UploadedSupportingDocs = res;
      }, error => {
        console.log(error);
      });
  }
  ViewUploadedDocs(FileContent, UploadedFileName) {
    //debugger
    let mimeType;
    const selectedFileType = UploadedFileName.split('.').pop();
    const FileType = [
      { key: "pdf", value: 'application/pdf', IsDownload: "0" }
    ];

    mimeType = FileType.filter((value) => value.key == selectedFileType);
    if (mimeType.length > 0) {
      this.spinner.show();
      var blob = this.base64ToBlob(FileContent, mimeType[0].value);
      if (mimeType[0].IsDownload == "1") {
        var link = window.document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = UploadedFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.spinner.hide();
      }
      else {
        var url = window.URL.createObjectURL(blob);
        window.open(url);
        this.spinner.hide();
      }
    }
  }
  RedirectToTakeAction(taskId: any, gciId: any,candidateName:any){
    this.route.navigate(["/takeaction"], { queryParams: { taskId: taskId,candidateName:candidateName } });
  }
  getTakeActionPendingDocsCount(search: any) {
    this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/GetEsignConsultantPendingPackagesCount", search)
      .subscribe(
        (response: any) => {
          this.dataService.setTakeActionCount(response);
          // console.log(response);
        },
        error => {
          console.log(error);
        });
  }
  GetViewCompletedDocsCount(search: any) {
    //debugger;
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/GetVendorConsultantCompleteDocsCount", search)
      .subscribe((response: any) => {
        //debugger;
        //console.log(response);
        this.dataService.setVendorViewCompeletedDocsCount(response);
      });
  }
  DynamicColumns = [];
  ExportToExcel() {
    this.spinner.show();
    this.DynamicColumns = [];
    this.DynamicColumns.push({ Required: true, field: "gci_Id", header:"gci_Id" });
   // this.DynamicColumns.push({ Required: true, field: "task_Id", header:"task_Id" });
    this.cols.map((value) => {
      this.DynamicColumns.push({ Required: value["checked"], field: value["field"], header: value["header"] });
    });
   
    //console.log(this.DynamicColumns)
    if (this.AdvanceSearch.CandidateName != "" || this.AdvanceSearch.ClientNames.length > 0
      || this.AdvanceSearch.EndClientName.length > 0 || this.AdvanceSearch.OPSExecutives.length > 0
      || this.AdvanceSearch.EsdFromDate.length > 0 || this.AdvanceSearch.EsdToDate.length > 0
      || this.AdvanceSearch.VendorCode != "") {
      this.AdvanceSearch.DynamicColumnsforExportToExcel = this.DynamicColumns;
      let url = environment.eSignApiUrl + "/api/VendorEsign/GetConsltantDataForExcel"
      this.dataService.Post(url, this.AdvanceSearch)
        .subscribe(
          (data: any) => {
            if (data.isSuccess) {
              this.content = data.data;
              var mimeType =
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              var blob = this.base64ToBlob(this.content, mimeType);
              var url = window.URL.createObjectURL(blob);
              var anchor = document.createElement('a');

              anchor.download = 'Consltants' + '.xlsx';
              this.toastr.success(anchor.download + ' Downloaded Successfully.');
              anchor.href = url;
              anchor.click();
            } else {
              this.toastr.error('Please filter data for export to excel');
              //alert(data.Data);
            }
          },
          (error) => { }
        );
    } else {
      this.toastr.error('Please filter data for export to excel');
      //alert("Please filter data for export to excel");
    }
    this.spinner.hide();
  }


  base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }
  wfstatus=null;
  changeStatus(e) {
    e.target.value == 1 ? this.AdvanceSearch.Status = 1 : this.AdvanceSearch.Status = 0;
    //console.log(e.target.value);
  }
  GetConsltantListAccordingToStatus(status: number, event) {
    //debugger;
    this.spinner.show();
    this.AdvanceSearch.Take=50;
    this.AdvanceSearch.Skip=0;
    this.AdvanceSearch.Status = status;
    this.AdvanceSearch.VendorCode = sessionStorage.getItem("VendorCode");
    this.candidateStatus=status;
    this.GetPartnerConsltantsDetails(this.AdvanceSearch);
    
    document.querySelectorAll('.activeInactive--modifier').forEach(function(item){
      item.classList.remove('active');
    });
    event.target.closest('.activeInactive--modifier').classList.add('active');
    this.spinner.hide();
  }
 // ConsltantList: any;
  GetPartnerConsltantsDetails(AdvanceSearch: any) {
    //console.log(AdvanceSearch)
    this.spinner.show();
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/GetPartnerConsultants", this.AdvanceSearch)
      .subscribe(
        (data) => {
          if (data != null) {
            this.candidateList.data = data.partnerConsultantsDTO;
           // console.log(this.candidateList.data)
            this.totalActiveConsCount = data.totalActiveConsCount;
            this.totalInactiveCount = data.totalInactiveCount;
            //this.updateIndex();
          }
          else {
          }
        },
        error => {
        });
        this.spinner.hide(); 
  }
  GridSetUp() {
    this.cols = [
      { checked: true, field: 'candidateName', header: 'CANDIDATE NAME', hcss: 'custom_th colw-16', bcss: 'custom_td colw-16' },
      { checked: true, field: 'clientName', header: 'CLIENT/END CLIENT ', hcss: 'custom_th colw-16', bcss: 'custom_td colw-16' },
      { checked: true, field: 'esd', header: 'START DATE', hcss: 'custom_th colw-8', bcss: 'custom_td colw-8' },
      { checked: true, field: 'status', header: 'STATUS', hcss: 'custom_th colw-5', bcss: 'custom_td colw-5' },
      { checked: true, field: 'projectLocation', header: 'PROJECT LOCATION', hcss: 'custom_th colw-12', bcss: 'custom_td colw-12' },
      { checked: true, field: 'recruiter', header: 'RECRUITER', hcss: 'custom_th colw-12', bcss: 'custom_td colw-12' },
      { checked: true, field: 'opsExecutive', header: 'OPS. EXECUTIVE', hcss: 'custom_th colw-12', bcss: 'custom_td colw-12' },
    ];
    this.columnsToDisplay = this.cols.map(col => col.field).splice(0, 7);
    //console.log(this.columnsToDisplay);
  }
  AdvanceSearchClick() {
    //debugger;
    this.spinner.show();
    this.AdvanceSearch.Skip = 0;
    this.AdvanceSearch.Take = 50;
    this.AdvanceSearch.VendorCode = sessionStorage.getItem("VendorCode");
    if (this.SelectedEsdDate!=null && this.SelectedEsdDate.length > 0) {
      this.AdvanceSearch.EsdFromDate = this.pipe.transform(this.SelectedEsdDate[0], 'MM/dd/yyyy');
      this.AdvanceSearch.EsdToDate = this.pipe.transform(this.SelectedEsdDate[1], 'MM/dd/yyyy');
    }
    this.advanceSearchPopupCSS="has-icon d-block has-dropdown has-advance-filter";
    //this.AdvanceSearch.Status=this.Status;
    
    this.GetPartnerConsltantsDetails(this.AdvanceSearch);
    this.candidateStatus=this.AdvanceSearch.Status;
    this.spinner.hide();
  }

  ClearSearchFields() {
    this.candidateStatus=1;
    this.AdvanceSearch.Skip=0;
    this.AdvanceSearch.Take=50;
    this.AdvanceSearch.Status = 1;
    this.AdvanceSearch.CandidateName = null;
    this.AdvanceSearch.ClientNames = null;
    this.AdvanceSearch.EndClientName = null;
    this.AdvanceSearch.OPSExecutives = null;
    this.AdvanceSearch.EsdFromDate = null;
    this.AdvanceSearch.EsdToDate = null;
    this.AdvanceSearch.DynamicColumnsforExportToExcel = null;
    this.SelectedEsdDate=null;
    this.AdvanceSearch.VendorCode = sessionStorage.getItem("VendorCode");
    this.GetPartnerConsltantsDetails(this.AdvanceSearch);
  }
  ResetSearchFields() {
    this.wfstatus=null;
    this.candidateStatus=1;
    this.AdvanceSearch.Skip=0;
    this.AdvanceSearch.Take=50;
    this.AdvanceSearch.Status = 1;
    this.AdvanceSearch.CandidateName = null;
    this.AdvanceSearch.ClientNames = null;
    this.AdvanceSearch.EndClientName = null;
    this.AdvanceSearch.OPSExecutives = null;
    this.AdvanceSearch.EsdFromDate = null;
    this.AdvanceSearch.EsdToDate = null;
    this.AdvanceSearch.DynamicColumnsforExportToExcel = null;
    this.SelectedEsdDate=null;
    this.AdvanceSearch.VendorCode = sessionStorage.getItem("VendorCode");
    this.GetPartnerConsltantsDetails(this.AdvanceSearch);
    this.advanceSearchPopupCSS="has-icon d-block has-dropdown has-advance-filter";
  }
  changeCSSAdvancefilterPopup(){
  this.advanceSearchPopupCSS="has-icon d-block has-dropdown has-advance-filter dropdown-on-show";
  }
  
  onTableScroll(e) {
   // debugger;
    if (e.srcElement.scrollLeft > 0 || e.srcElement.scrollRight > 0 || e.srcElement.scrollLeft == 0 || e.srcElement.scrollRight == 0) {
      if (e.srcElement.scrollTop > 0) {
        const tableViewHeight = e.target.offsetHeight // viewport
        const tableScrollHeight = e.target.scrollHeight // length of all table
        const scrollLocation = e.target.scrollTop; // how far user scrolled
        // If the user has scrolled within 200px of the bottom, add more data
        const buffer = 100;
        const limit = tableScrollHeight - tableViewHeight - buffer;
        if (scrollLocation > limit) {
          if(this.AdvanceSearch.Status==1){
           this.totalcount=this.totalActiveConsCount;
          }
          else{
           this.totalcount=this.totalInactiveCount;
          }
          if (this.totalcount>50 && Number(this.candidateList.data.length)>49) {
            this.AdvanceSearch.Skip = 50;
            this.AdvanceSearch.Take = 50;
            this.AdvanceSearch.VendorCode = sessionStorage.getItem("VendorCode");
            this.GetPartnerConsltantsDetails(this.AdvanceSearch);
          }
          else {
            return false;
          }
        }
      }
    }
  }
  TableColumnPopup() {
    this.IsTableColumnPopupOpen = !this.IsTableColumnPopupOpen;
    if (this.IsTableColumnPopupOpen) { this.TableColumnPopupclass = "filter_wrap table_columns active" }
    else { this.TableColumnPopupclass = "filter_wrap table_columns" }
  }
}
